<template>
  <component
    :is="selectType"
    ref="select"
    v-model="agValue"
    v-bind="componentProps"
    @blur="handleBlur"
    @focus="handleFocus"
    @change="handleChange"
  />
</template>

<script>
import agEditorMixins from './ag-editor-mixins'

export default {
  name: 'AgSelect',
  mixins: [agEditorMixins],
  props: {},
  data() {
    return {}
  },
  computed: {
    selectType() {
      return this.componentProps.selectType
    },
    componentProps() {
      return Object.assign(
        {},
        {
          selectType: 'horizon-select',
          autoInit: false,
          autoFocus: false,
          option: {}
        },
        this.params?.cellEditorComponentProps || {}
      )
    }
  },
  mounted() {
    this.agValue = this.params.value
    this.$nextTick(() => {
      const { autoFocus } = this.componentProps
      if (autoFocus) {
        this.focusSelect()
      }
    })
  },
  methods: {
    triggerChange(records, type) {
      const { cellEditorComponentProps, ...restAgParams } = this.params

      const { change } = cellEditorComponentProps || {}
      change?.(this.agValue, records, { agParams: restAgParams }, type)
    },
    handleChange(val, type) {
      const { multiple } = this.componentProps
      if (multiple) {
        const valArr = Array.isArray(val) ? val : [val]
        this.triggerChange(valArr, type)
      } else {
        this.triggerChange(val, type)
      }
    },
    handleBlur(e) {
      this.triggerBlur(e)
    },
    handleFocus(e) {
      this.triggerFocus(e)
    },
    focusSelect() {
      this.$nextTick(() => {
        this.$refs.select.focus()
      })
    }
  }
}
</script>
